import { pList, rSorgulamaSonuclari, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError, IKeyValPair } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';
import rList from '../../../../api/models/rList';
import pSorgulamaSonuclari from '../../../../api/models/pSorgulamaSonuclari';


export const action_async_start = (body: pSorgulamaSonuclari): IPromiseAction<pSorgulamaSonuclari> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_SORGULAMASONUCLARILISTE,
    new Api.Bilgi.SorgulamaSonuclariListe().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rList<rSorgulamaSonuclari> | null | undefined,
  error: IError | null | undefined
): IApiAction<rSorgulamaSonuclari[]> =>
  ActionFunctions.action_async_complete_api<rSorgulamaSonuclari[]>(
    ActionSubTypes.API_SORGULAMASONUCLARILISTE,
    data?.Values,
    error
  );
